"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _carbonComponentsReact = require("carbon-components-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LabelFactory = _interopRequireDefault(require("../../common/FormElement/LabelFactory"));
var _WebsiteInputValidator = _interopRequireDefault(require("./WebsiteInputValidator"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.website-input {\n  width: 100%;\n  margin-bottom: 1.5rem; }\n  .website-input .bx--label {\n    color: #4c4c4c; }\n  .website-input .tooltip {\n    color: #a8a8a8; }\n";
  const fileName = "WebsiteInput_WebsiteInput";
  const element = document.querySelector("style[data-sass-component='WebsiteInput_WebsiteInput']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const WebsiteInput = props => {
  const onChange = event => {
    const value = event.target.value;
    const isPatternValid = value ? _WebsiteInputValidator.default.validatePattern(value) : true;
    const error = isPatternValid ? null : props.invalidPatternText;
    props.onChange(event, value, error);
  };
  const customLabel = /*#__PURE__*/_react.default.createElement("div", null, props.label && _LabelFactory.default.create(props.label, props.required), props.tooltip && /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip"
  }, props.tooltip));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'website-input'
  }, /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TextInput, {
    id: props.id,
    labelText: customLabel,
    name: props.id,
    onChange: onChange,
    placeholder: props.placeholder,
    helperText: props.helperText ? props.helperText : false,
    invalid: Boolean(props.invalidText),
    invalidText: props.invalidText,
    value: props.value
  }));
};
WebsiteInput.propTypes = {
  id: _propTypes.default.string.isRequired,
  label: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  invalidPatternText: _propTypes.default.string.isRequired,
  required: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  helperText: _propTypes.default.string,
  value: _propTypes.default.string,
  invalidText: _propTypes.default.string,
  type: _propTypes.default.string,
  tooltip: _propTypes.default.string
};
WebsiteInput.defaultProps = {
  type: 'WebsiteInput' // todo, https://stackoverflow.com/q/72446985/4840661
};
var _default = exports.default = WebsiteInput;